import { Image, IStackProps, VStack } from 'native-base';
import React, { ReactNode, useEffect, useState } from 'react';

import AspectImage from 'app/components/AspectImage';
import { useProductContext } from 'app/providers/ProductProvider';
import { getCityName, getLogoWhite } from 'app/services/ProductHelper';

export type ProductLogoProps = IStackProps & {
  children?: ReactNode;
};

export default function ProductLogo({ ...props }: ProductLogoProps) {
  const { productContent } = useProductContext();
  const logo = getLogoWhite(productContent);
  const [[width, height], setSize] = useState([1, 1]);

  // CMS started returning 0 width and height for some svg images
  useEffect(() => {
    if (logo.width) return;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: types are wrong
    Image.getSize(logo.url, (w, h) => {
      setSize([w, h]);
    });
  }, [logo.url, logo.width]);

  return (
    <VStack alignItems="center" testID="ProductLogo" {...props}>
      <AspectImage
        // can't get backdrop-filter: drop-shadow working here
        _web={{ shadow: 'none' }}
        alt={getCityName(productContent)}
        h="20"
        ratio={logo.width ? logo.ratio : width / height}
        shadow={9}
        url={logo.url}
      />
    </VStack>
  );
}
